import { render, staticRenderFns } from "./salarydetail.vue?vue&type=template&id=4f389ff4&scoped=true&"
import script from "./salarydetail.vue?vue&type=script&lang=js&"
export * from "./salarydetail.vue?vue&type=script&lang=js&"
import style0 from "./salarydetail.vue?vue&type=style&index=0&id=4f389ff4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f389ff4",
  null
  
)

export default component.exports